import api from './'

export default {

    /**
     * Get stats
     * @param params
     */
    get(params) {
        return api
            .get(`/stats`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    }

}
